import * as actionTypes from '../actions/actionTypes'

const initialState = {
  pagination: { total: 0, to: 0, lastPage: 1, from: 0, currentPage: 1, perPage: 10 },
  records: [],
  company: [],
  filterLevelGroup: [],
  filterLoading: false,
  filterActive: [],
  appraisalType: [],
  selectedRecord: null,
  loadingStates: []
}

const fetchLevelGroupStart = (state, action) => {
  return { ...state, loading: true, loadingStates: [...state.loadingStates, 'record'] }
}

const fetchLevelGroupSuccess = (state, action) => {
  let { pagination, records } = action

  records = records.map(res => {
    let data = res
    return {
      ...data,
      company_name: data?.company?.company_name
    }
  })
  return {
    ...state,
    records: records,
    loading: false,
    loadingStates: state.loadingStates.filter(item => item !== 'record'),
    pagination: pagination
  }
}

const fetchLevelGroupFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    loadingStates: state.loadingStates.filter(item => item !== 'record'),
    message: action.errorMessage
  }
}

const fetchCompanyStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchCompanySuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    company: action.data
  }
}

const fetchCompanyFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    message: action.errorMessage
  }
}

const fetchLevelGroupFilterLevelGroupStart = (state, action) => {
  return { ...state, filterLoading: true }
}

const fetchLevelGroupFilterLevelGroupSuccess = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    filterLevelGroup: action.data
  }
}

const fetchLevelGroupFilterLevelGroupFailed = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    message: action.errorMessage
  }
}

const fetchLevelGroupFilterActiveStart = (state, action) => {
  return { ...state, filterLoading: true }
}

const fetchLevelGroupFilterActiveSuccess = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    filterActive: action.data
  }
}

const fetchLevelGroupFilterActiveFailed = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    message: action.errorMessage
  }
}

const fetchAppraisalTypeOptionsStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchAppraisalTypeOptionsSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    appraisalType: action.data
  }
}

const fetchAppraisalTypeOptionsFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    message: action.errorMessage
  }
}

const createLevelGroupStart = (state, action) => {
  return { ...state, loading: true }
}

const createLevelGroupSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const createLevelGroupFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

const updateLevelGroupStart = (state, action) => {
  return { ...state, loading: true }
}

const updateLevelGroupSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const updateLevelGroupFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

const deleteLevelGroupStart = (state, action) => {
  return { ...state, loading: true }
}

const deleteLevelGroupSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const deleteLevelGroupFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

const fetchLevelGroupByIdSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    selectedRecord: action.recordData,
    loadingStates: state.loadingStates.filter(item => item !== 'record')
  }
}

const clearSelectedLevelGroupRecord = (state, action) => {
  return {
    ...state,
    selectedRecord: { is_active: true },
    success: false
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_LEVEL_GROUP_START:
      return fetchLevelGroupStart(state, action)
    case actionTypes.FETCH_LEVEL_GROUP_SUCCESS:
      return fetchLevelGroupSuccess(state, action)
    case actionTypes.FETCH_LEVEL_GROUP_FAILED:
      return fetchLevelGroupFailed(state, action)
    case actionTypes.CREATE_LEVEL_GROUP_START:
      return createLevelGroupStart(state, action)
    case actionTypes.CREATE_LEVEL_GROUP_SUCCESS:
      return createLevelGroupSuccess(state, action)
    case actionTypes.CREATE_LEVEL_GROUP_FAILED:
      return createLevelGroupFailed(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_START:
      return fetchCompanyStart(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_SUCCESS:
      return fetchCompanySuccess(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_FAILED:
      return fetchCompanyFailed(state, action)
    case actionTypes.FETCH_LEVEL_GROUP_FILTER_LEVEL_GROUP_START:
      return fetchLevelGroupFilterLevelGroupStart(state, action)
    case actionTypes.FETCH_LEVEL_GROUP_FILTER_LEVEL_GROUP_SUCCESS:
      return fetchLevelGroupFilterLevelGroupSuccess(state, action)
    case actionTypes.FETCH_LEVEL_GROUP_FILTER_LEVEL_GROUP_FAILED:
      return fetchLevelGroupFilterLevelGroupFailed(state, action)
    case actionTypes.FETCH_LEVEL_GROUP_FILTER_ACTIVE_START:
      return fetchLevelGroupFilterActiveStart(state, action)
    case actionTypes.FETCH_LEVEL_GROUP_FILTER_ACTIVE_SUCCESS:
      return fetchLevelGroupFilterActiveSuccess(state, action)
    case actionTypes.FETCH_LEVEL_GROUP_FILTER_ACTIVE_FAILED:
      return fetchLevelGroupFilterActiveFailed(state, action)
    case actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_START:
      return fetchAppraisalTypeOptionsStart(state, action)
    case actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_SUCCESS:
      return fetchAppraisalTypeOptionsSuccess(state, action)
    case actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_FAILED:
      return fetchAppraisalTypeOptionsFailed(state, action)
    case actionTypes.UPDATE_LEVEL_GROUP_START:
      return updateLevelGroupStart(state, action)
    case actionTypes.UPDATE_LEVEL_GROUP_SUCCESS:
      return updateLevelGroupSuccess(state, action)
    case actionTypes.UPDATE_LEVEL_GROUP_FAILED:
      return updateLevelGroupFailed(state, action)
    case actionTypes.DELETE_LEVEL_GROUP_START:
      return deleteLevelGroupStart(state, action)
    case actionTypes.DELETE_LEVEL_GROUP_SUCCESS:
      return deleteLevelGroupSuccess(state, action)
    case actionTypes.DELETE_LEVEL_GROUP_FAILED:
      return deleteLevelGroupFailed(state, action)
    case actionTypes.FETCH_LEVEL_GROUP_BY_ID_SUCCESS:
      return fetchLevelGroupByIdSuccess(state, action)
    case actionTypes.CLEAR_SELECTED_LEVEL_GROUP_RECORD:
      return clearSelectedLevelGroupRecord(state, action)
    case actionTypes.SIGNOUT_SUCCESS:
    case actionTypes.SIGNOUT_FAILED:
      return { ...initialState }
    default:
      return state
  }
}

export default reducer
